import { FC } from "react";
import InfoIcon from "@/assets/images/dashboard/Info.svg";

interface ActionPlanCardProps {
  title: string;
  subtitle?: string;
  description: string;
  imageUrl?: string;
  icon?: React.ReactNode;
  percentChange?: number;
  doctorName?: string;
}

export const ActionPlanCard: FC<ActionPlanCardProps> = ({
  title,
  subtitle = "New Goal",
  description,
  imageUrl,
  icon,
  percentChange,
  doctorName,
}) => {
  return (
    <div className="rounded-2xl bg-white p-6 shadow-sm">
      <div className="mb-6 flex items-center gap-3">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={title}
              className="h-8 w-8 object-contain"
            />
          ) : (
            icon
          )}
        </div>
        <div className="flex-1">
          <h4 className="text-2xl font-light text-gray-900">{title}</h4>
          {doctorName && (
            <p className="text-sm font-light text-gray-500">
              Guided by {doctorName}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="mb-1 flex items-center gap-2">
            <p className="text-sm font-medium text-gray-600">{subtitle}</p>
            <img src={InfoIcon} alt="Info" className="h-4 w-4" />
          </div>
          <p className="text-sm text-gray-400">{description}</p>
        </div>
        {percentChange !== undefined && (
          <div className="flex items-center gap-1 rounded-full bg-green-50 px-2 py-1">
            <span className="text-sm font-semibold text-green-600">
              +{percentChange}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
